//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfButton from "../../atoms/SfButton/SfButton.vue";
import SfHeading from "../../atoms/SfHeading/SfHeading.vue";

export default {
  name: "SfCardHorizontal",
  components: {
    SfButton,
    SfHeading,
  },
  props: {
    image: {
      type: Object,
      default: () => ({
        desktop: "",
        mobile: "",
        alt: "",
      }),
    },
    title: {
      type: String,
      default: "",
    },
    titleLevel: {
      type: [Number, String],
      default: 2,
    },
    description: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "",
    },
    secondaryLink: {
      type: String,
      default: "",
    },
    secondaryButtonText: {
      type: String,
      default: "",
    },
    themeColor: {
      type: String,
      default: "var(--c-secondary-turquoise)",
    },
    subTitle: {
      type: String,
      default: "",
    },
    layout: {
      type: String,
      default: "layout1",
    }

  },
};
